import { render, staticRenderFns } from "./RTablePagination.vue?vue&type=template&id=47bfbff2&"
import script from "./RTablePagination.vue?vue&type=script&lang=js&"
export * from "./RTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports